module.exports = __webpack_public_path__ + "static/images/social-facebook.b8544d38500f5e65b05300ecdc406669.svg";